import { render, staticRenderFns } from "./PresetMenu.vue?vue&type=template&id=27087547&"
import script from "./presetMenu.js?vue&type=script&lang=js&"
export * from "./presetMenu.js?vue&type=script&lang=js&"
import style0 from "./PresetMenu.vue?vue&type=style&index=0&id=27087547&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports